module.exports = __webpack_public_path__ + "img/van-hoa.9b1f4a4e.png";